import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./TitleSection.css";

class TitleSection extends PureComponent {
  componentDidMount() {
    this.updateDocumentTitle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageTitle !== this.props.pageTitle) {
      this.updateDocumentTitle();
    }
  }

  updateDocumentTitle() {
    const { pageTitle } = this.props;
    if (pageTitle) {
      document.title = pageTitle;
    }
  }

  render() {
    const {
      title,
      body,
      line2,
      linkPreText,
      linkText,
      linkPostText,
      linkUrl,
    } = this.props;

    if (!title) {
      return null;
    }

    const showLink = linkUrl && linkText;

    return (
      <div className="title-section row justify-content-center">
        <div className="col-xl-7 col-lg-8 col-md-8 col-sm-10">
          <h1 className="title-section__title">{title}</h1>
          {body && <p className="title-section__body">{body}</p>}
          {line2 && (
            <p className="title-section__body title-section__body--line2">
              {line2}
            </p>
          )}
          {showLink && (
            <p className="title-section__link">
              {linkPreText}
              <Link
                to={{
                  pathname: linkUrl,
                  search: window.location.search,
                }}
              >
                {linkText}
              </Link>
              {linkPostText}
            </p>
          )}
        </div>
      </div>
    );
  }
}

TitleSection.propTypes = {
  pageTitle: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  line2: PropTypes.string,
  linkPreText: PropTypes.string,
  linkText: PropTypes.string,
  linkPostText: PropTypes.string,
  linkUrl: PropTypes.string,
};

TitleSection.defaultProps = {
  pageTitle: "",
  title: "",
  body: "",
  line2: "",
  linkPreText: "",
  linkText: "",
  linkPostText: "",
  linkUrl: "",
};

export default TitleSection;
